import * as z from "zod";

export const workflowPageViewSchema = z.object({
  workflowId: z.string(),
  workflowName: z.string(),
  // Results recorded before chats opened pages on the workflow itself lack these two.
  spaceId: z.string().optional(),
  spaceSlug: z.string(),
  branchId: z.string().nullable(),
  route: z.string(),
  stepDir: z.string().optional(),
  externalId: z.string().nullable(),
});

export type WorkflowPageView = z.infer<typeof workflowPageViewSchema>;
